import { render, staticRenderFns } from "./HomeInfoGeneral.vue?vue&type=template&id=5d3d4dab&"
import script from "./HomeInfoGeneral.vue?vue&type=script&lang=js&"
export * from "./HomeInfoGeneral.vue?vue&type=script&lang=js&"
import style0 from "./HomeInfoGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports